import { render, staticRenderFns } from "./ProductCross.vue?vue&type=template&id=2571761a&"
import script from "./ProductCross.vue?vue&type=script&lang=js&"
export * from "./ProductCross.vue?vue&type=script&lang=js&"
import style0 from "./ProductCross.vue?vue&type=style&index=0&id=2571761a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports